<div cdkDropList (cdkDropListDropped)="onDrop($event)" class="sortable-container drag-boundary">
  <rt-list-sortable-item
    *ngFor="let item of items; trackBy: trackItem"
    [title]="item.title! || item.name!"
    [item]="item"
    [processing]="(isProcessing$(item) | async)!"
    [renamable]="isAllowedTo('renamable', item)"
    [removable]="isAllowedTo('removable', item)"
    (delete)="delete(item)"
    (nameChange)="nameChanged(item, $event)"
    cdkDrag
    cdkDropListLockAxis="y"
    cdkDragBoundary=".drag-boundary"
  >
  </rt-list-sortable-item>
</div>
